import React from 'react';
import searchImg from '../img/icons8-whatsapp-32.png';
import {buildDefaultWhatsAppMessage, buildWhatsAppUrl} from '../utils/whatsappUtils';

const WhatsAppButton = ({phoneNumber, message, personName}) => {
    const whatsappMessage = message ?? (personName ? buildDefaultWhatsAppMessage(personName) : undefined);
    const whatsappUrl = buildWhatsAppUrl(phoneNumber, whatsappMessage);

    if (!whatsappUrl) {
        return null;
    }

    return (
        <a
            href={whatsappUrl}
            className="whatsapp-button"
            target="_blank"
            rel="noopener noreferrer"
            title="Abrir WhatsApp"
        >
            <img src={searchImg} alt="WhatsApp"/>
        </a>
    );
};

export default WhatsAppButton;
